import type { SchedulingEnrollment } from '@/types/scheduling';
import { endOfDay, isPast } from 'date-fns';
import { enrollmentDateToCenterDay } from './enrollmentDateToLocalDay';

const lastDayOfEnrollment = (enrollment: SchedulingEnrollment, timeZone: string): Date | undefined =>
  enrollment.enrollmentEndDate ? enrollmentDateToCenterDay(enrollment.enrollmentEndDate, timeZone) : undefined;

/**
 * MYM-260: read on the center's clock, like the booking calendar it gates. On the last day of an
 * enrollment a device-clock reading would call it expired while the calendar still offered the day,
 * or the reverse.
 */
export const isEnrollmentExpired = (enrollment: SchedulingEnrollment, timeZone: string): boolean => {
  const lastDay = lastDayOfEnrollment(enrollment, timeZone);

  return !!lastDay && isPast(endOfDay(lastDay));
};
